import Toast from '../components/Toast';

const { daum } = window;

const getZoomLevel = (len = 0) => {
  return len === 2 ? 10 : len === 5 ? 8 : 6
};

const InitMap = (elem, position, code) => {
  const zoom = code === 'univ' || code === 'subway' ? 6 : getZoomLevel(code.length);
  const options = {
    center: new daum.maps.LatLng(position[0], position[1]),
    level: zoom
  };

  const map = new daum.maps.Map(elem, options); //지도 생성 및 객체 리턴

  // 지도 확대 축소를 제어할 수 있는  줌 컨트롤을 생성합니다
  const zoomControl = new daum.maps.ZoomControl();
  map.addControl(zoomControl, daum.maps.ControlPosition.RIGHT);

  // 마우스 휠로 지도 확대,축소 가능여부를 설정합니다
  map.setZoomable(false); // true: 켜기, false: 끄기
  
  return map
}

const MakeDragableMarker = (map, position, type, callback) => {
  // 마커가 표시될 위치입니다 
  const markerPosition = new daum.maps.LatLng(position[0], position[1]); 

  // 마커를 생성합니다
  const marker = new daum.maps.Marker({
    position: markerPosition
  });

  // 마커가 지도 위에 표시되도록 설정합니다
  marker.setMap(map);

  // 마커가 드래그 가능하도록 설정합니다 
  marker.setDraggable(true);

  // 지도에 클릭 이벤트를 등록합니다
  // 지도를 클릭하면 마지막 파라미터로 넘어온 함수를 호출합니다
  daum.maps.event.addListener(map, 'click', e => {
    // 클릭한 위도, 경도 정보를 가져옵니다 
    const latlng = e.latLng;
    
    // 마커 위치를 클릭한 위치로 옮깁니다
    marker.setPosition(latlng);

    callback({
      x: latlng.getLng(),
      y: latlng.getLat(),
    }, type);
  });

  // 마커에 dragend 이벤트를 등록합니다
  daum.maps.event.addListener(marker, 'dragend', () => {
    const pos = marker.getPosition();
    
    callback({
      x: pos.ib,
      y: pos.jb
    }, type);
  });

  return marker;
}

const MakeClickableMarker = (map, callback) => {
  // 지도를 클릭한 위치에 표출할 마커입니다
  var marker = new daum.maps.Marker({ 
    // 지도 중심좌표에 마커를 생성합니다 
    position: map.getCenter()
  }); 

  // 지도에 마커를 표시합니다
  marker.setMap(map);

  // 마커가 드래그 가능하도록 설정합니다 
  marker.setDraggable(true);

  // 지도에 클릭 이벤트를 등록합니다
  // 지도를 클릭하면 마지막 파라미터로 넘어온 함수를 호출합니다
  daum.maps.event.addListener(map, 'click', e => {
    // 클릭한 위도, 경도 정보를 가져옵니다 
    const latlng = e.latLng;
    
    // 마커 위치를 클릭한 위치로 옮깁니다
    marker.setPosition(latlng);

    callback({
      x: latlng.getLng(),
      y: latlng.getLat(),
    });
  });

  // 마커에 dragend 이벤트를 등록합니다
  daum.maps.event.addListener(marker, 'dragend', e => {
    //  마커의 드래그가 종료될 때 마커 이미지를 원래 이미지로 변경합니다
    const pos = marker.getPosition();
    
    callback({
      x: pos.ib,
      y: pos.jb
    });
  });

  return marker;
}

const MakeClickableMarker2 = (map, callback) => {
  // 지도를 클릭한 위치에 표출할 마커입니다
  var marker = new daum.maps.Marker({ 
    // 지도 중심좌표에 마커를 생성합니다 
    position: map.getCenter()
  }); 

  // 지도에 마커를 표시합니다
  marker.setMap(map);

  // 마커가 드래그 가능하도록 설정합니다 
  marker.setDraggable(true);

  // 지도에 클릭 이벤트를 등록합니다
  // 지도를 클릭하면 마지막 파라미터로 넘어온 함수를 호출합니다
  daum.maps.event.addListener(map, 'click', e => {
    // 클릭한 위도, 경도 정보를 가져옵니다 
    const latlng = e.latLng;

    callback({
      x: latlng.getLng(),
      y: latlng.getLat(),
    });
  });

  // 마커에 dragend 이벤트를 등록합니다
  daum.maps.event.addListener(marker, 'dragend', e => {
    //  마커의 드래그가 종료될 때 마커 이미지를 원래 이미지로 변경합니다
    const pos = marker.getPosition();
    
    callback({
      x: pos.ib,
      y: pos.jb
    });
  });

  return marker;
}

const DrawPolygon = (map, undo, redo, type, callback) => {

  let drawingMode = [daum.maps.drawing.OverlayType.POLYGON];

  if (type === 'add') {
    drawingMode = [
      daum.maps.drawing.OverlayType.POLYGON,
      daum.maps.Drawing.OverlayType.MARKER,
    ];
  }

  const options = { // Drawing Manager를 생성할 때 사용할 옵션입니다
    map: map, // Drawing Manager로 그리기 요소를 그릴 map 객체입니다
    drawingMode: drawingMode, // Drawing Manager로 제공할 그리기 요소 모드입니다
    // 사용자에게 제공할 그리기 가이드 툴팁입니다
    // 사용자에게 도형을 그릴때, 드래그할때, 수정할때 가이드 툴팁을 표시하도록 설정합니다
    guideTooltip: ['draw', 'drag', 'edit'], 
    markerOptions: { // 마커 옵션입니다 
      draggable: true, // 마커를 그리고 나서 드래그 가능하게 합니다 
      removable: true // 마커를 삭제 할 수 있도록 x 버튼이 표시됩니다  
    },
    polygonOptions: {
      draggable: true,
      removable: true,
      editable: true,
      strokeWeight: 3,
      strokeColor: '#0950bb',
      strokeStyle: 'solid',
      strokeOpacity: 1,
      fillColor: '#125FEB',
      fillOpacity: 0.3,
      hintStrokeStyle: 'dash',
      hintStrokeOpacity: 0.5
    }
  };

  const manager = new daum.maps.Drawing.DrawingManager(options);

  manager.addListener('state_changed', () => {
    const data = manager.getData();
    const marker = data.marker;
    const polygon = data.polygon;

    const pLen = (polygon && polygon.length) || 0;
    const mLen = (marker && marker.length) || 0;

    if (pLen > 0 || mLen > 0) {
      if (type === 'add') {
        
        
        const x = (marker[0] && marker[0].x) || 126.977969;
        const y = (marker[0] && marker[0].y) || 37.566535;
        const points = (polygon[0] && polygon[0].points) || [];
        
        callback({
          polygon: points,
          marker: {
            x: x,
            y: y
          },
        });
        
      } else {
        const points = data.polygon[0].points;
        callback(points);
      }

    } else if (pLen === 0 && mLen === 0) {
      callback([]);
    }

    // 되돌릴 수 있다면 undo 버튼을 활성화 시킵니다 
    if (manager.undoable()) {
      undo.disabled = false;
      undo.className = "";
    } else { // 아니면 undo 버튼을 비활성화 시킵니다 
      undo.disabled = true;
      undo.className = "disabled";
    }
  
    // 취소할 수 있다면 redo 버튼을 활성화 시킵니다 
    if (manager.redoable()) {
      redo.disabled = false;
      redo.className = "";
    } else { // 아니면 redo 버튼을 비활성화 시킵니다 
      redo.disabled = true;
      redo.className = "disabled";
    }
  });

  manager.addListener('remove', () => {
    manager.select(daum.maps.Drawing.OverlayType.POLYGON);
  });

  return manager;
}

const Toolbox = (map, manager) => {
  // Toolbox를 생성합니다. 
  // Toolbox 생성 시 위에서 생성한 DrawingManager 객체를 설정합니다.
  // DrawingManager 객체를 꼭 설정해야만 그리기 모드와 매니저의 상태를 툴박스에 설정할 수 있습니다.
  const toolbox = new daum.maps.Drawing.Toolbox({drawingManager: manager});
  
  // 지도 위에 Toolbox를 표시합니다
  // daum.maps.ControlPosition은 컨트롤이 표시될 위치를 정의하는데 TOP은 위 가운데를 의미합니다.
  map.addControl(toolbox.getElement(), daum.maps.ControlPosition.TOP);

  manager.addListener('drawend', e => {
    const type = e.overlayType;
    // 그리기 요소 타입을 선택 취소
    const data = manager.getData();
    
    if (data[type].length > 1) {
      // 이미 폴리곤이나 마커가 있는데 또 그릴경우 또그린거 제거
      manager.remove(e.currentTarget);
      Toast.error('폴리곤과 마커는 하나씩만 생성할수있습니다.')
    }
  });

  return toolbox;
}

export default {
  InitMap,
  MakeDragableMarker,
  MakeClickableMarker,
  MakeClickableMarker2,
  DrawPolygon,
  Toolbox,
};


// WEBPACK FOOTER //
// ./client/utils/map.js